<template>
  <v-container fluid>
    <PageTitle>
      Email #{{ message.id }}
    </PageTitle>
    <MessageCard :message="message">
    </MessageCard>
  </v-container>
</template>
<script>

import MessageCard from './components/MessageCard';
import PageTitle from '../../components/PageTitle.vue';

export default {
  components: {PageTitle, MessageCard},
  props: {
    message: {
      type: Object,
      required: true,
    }
  },
}
</script>
